
(() => {
  if (window.nhProductPilot) return;
  window.nhProductPilot = true;

  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-nh-product]')
      ? [scope]
      : scope.querySelectorAll('[data-nh-product]');

    roots.forEach((root) => {
      if (root.dataset.nhProductInitialized) return;
      const section = root.closest('.shopify-section') || root.parentElement;
      const sticky = section.querySelector('.nh-pdp-sticky');
      const mainButton = root.querySelector('[data-main-product-add-to-cart]');
      const stickyButton = sticky?.querySelector('[data-nh-sticky-add]');
      if (!mainButton) return;
      root.dataset.nhProductInitialized = 'true';

      const stickyPrice = sticky?.querySelector('[data-nh-sticky-price]');
      const variants = root.querySelector('product-variants[data-main-product-variants]');
      const form = mainButton.closest('form');
      const availability = root.querySelector('[data-nh-availability]');
      const giftCard = root.hasAttribute('data-nh-gift-card');
      let variantStates = [];
      try {
        const states = JSON.parse(section.querySelector('[data-nh-variant-states]')?.textContent || '[]');
        if (Array.isArray(states)) variantStates = states;
      } catch {}
      const stateById = new Map(variantStates.map((variant) => [String(variant.id), variant]));
      const media = window.matchMedia('(max-width: 767px)');
      const controller = new AbortController();
      let frame = 0;
      let destroyed = false;
      let stickySubmission = false;
      let wasWorking = false;
      let previousInlineError = null;

      const selectedState = () => {
        const initialized = variants && 'currentVariant' in variants;
        const choosing = variants && (initialized
          ? variants.variantRequired && variants.noVariantSelectedYet
          : variants.hasAttribute('data-variant-required'));
        if (choosing) return { variant: null, choosing: true };
        if (initialized) {
          const current = variants.currentVariant;
          return {
            variant: current ? { ...current, ...stateById.get(String(current.id)) } : null,
            choosing: false
          };
        }
        const selectedId = form?.querySelector('[name="id"]')?.value;
        return { variant: stateById.get(String(selectedId)) || null, choosing: false };
      };

      const synchronizeDetails = ({ variant, choosing }) => {
        if (availability) {
          const status = choosing ? 'choose' : !variant ? 'unavailable'
            : !variant.available ? 'soldOut' : variant.preorder ? 'preorder' : 'available';
          const label = availability.dataset[`${status}Text`] || root.dataset[`${status}Text`];
          const text = availability.querySelector('[data-nh-availability-text]') || availability;
          if (label && text.textContent !== label) text.textContent = label;
          if (availability.dataset.state !== status) availability.dataset.state = status;
        }
        ['sku', 'barcode'].forEach((field) => {
          root.querySelectorAll(`[data-nh-variant-${field}]`).forEach((element) => {
            const value = variant?.[field] || '';
            if (element.textContent !== String(value)) element.textContent = String(value);
            const row = element.closest('[data-nh-variant-row]')
              || element.closest('.nh-pdp-specs > div');
            if (row && row.hidden !== !value) row.hidden = !value;
          });
        });
      };

      const revealError = (element) => {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        element.scrollIntoView({ block: 'center', behavior });
        if (element.matches('input, select, textarea, button')) element.focus({ preventScroll: true });
      };

      const overlayIsVisible = () => {
        if (document.body.classList.contains('sidebar-opened') || document.fullscreenElement) return true;
        return [...document.querySelectorAll(
          '.sidebar--opened, #zoom.opened, .video-popup.video-opened, dialog[open], [role="dialog"][aria-modal="true"]'
        )].some((overlay) => {
          if (overlay.hidden || overlay.getAttribute('aria-hidden') === 'true') return false;
          const style = window.getComputedStyle(overlay);
          return style.display !== 'none' && style.visibility !== 'hidden'
            && Number(style.opacity) !== 0 && overlay.getClientRects().length > 0;
        });
      };

      const update = () => {
        frame = 0;
        if (destroyed || !root.isConnected) return;
        const state = selectedState();
        synchronizeDetails(state);
        const working = mainButton.classList.contains('working');
        if (stickySubmission && wasWorking && !working) {
          stickySubmission = false;
          const error = root.querySelector('#product-page-form-error-cart-alert');
          if (error && error !== previousInlineError && error.getClientRects().length) revealError(error);
        }
        wasWorking = working;
        if (!sticky || !stickyButton) return;
        const disabled = mainButton.disabled || mainButton.classList.contains('disabled')
          || mainButton.getAttribute('aria-disabled') === 'true' || working;
        stickyButton.disabled = disabled;
        if (working) stickyButton.setAttribute('aria-busy', 'true');
        else stickyButton.removeAttribute('aria-busy');
        const label = mainButton.querySelector('[data-js-product-add-to-cart-text]')?.textContent.trim();
        if (label && stickyButton.textContent.trim() !== label) stickyButton.textContent = label;

        const prices = [
          root.querySelector('[data-js-product-price-compact]'),
          root.querySelector('[data-js-product-price-extended]')
        ];
        const price = prices.filter((container) => container && !container.classList.contains('hide'))
          .map((container) => container.querySelector('[data-js-product-price-original]')?.textContent.trim())
          .find(Boolean) || '';
        const displayPrice = state.variant || state.choosing ? price : '';
        if (stickyPrice && stickyPrice.textContent !== displayPrice) {
          stickyPrice.textContent = displayPrice;
        }

        const hasPassedButton = mainButton.getBoundingClientRect().bottom <= 0;
        const visible = !giftCard && media.matches && hasPassedButton && !overlayIsVisible();
        if (sticky.hidden === visible) sticky.hidden = !visible;
      };

      const scheduleUpdate = () => {
        if (!frame && !destroyed) frame = window.requestAnimationFrame(update);
      };

      stickyButton?.addEventListener('click', () => {
        update();
        if (!giftCard && !stickyButton.disabled) {
          const invalid = form?.querySelector('input:invalid, select:invalid, textarea:invalid');
          if (invalid) {
            revealError(invalid);
            form.reportValidity();
            return;
          }
          previousInlineError = root.querySelector('#product-page-form-error-cart-alert');
          stickySubmission = true;
          mainButton.click();
          scheduleUpdate();
        }
      }, { signal: controller.signal });

      const buttonObserver = new MutationObserver(scheduleUpdate);
      buttonObserver.observe(mainButton, {
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled']
      });


      const overlayObserver = new MutationObserver((records) => {
        if (records.some(({ target }) => !sticky?.contains(target))) scheduleUpdate();
      });
      overlayObserver.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden', 'aria-modal']
      });

      variants?.addEventListener('VARIANT_CHANGE', scheduleUpdate, { signal: controller.signal });
      if (variants && !('currentVariant' in variants)) {
        customElements.whenDefined('product-variants').then(scheduleUpdate);
      }
      document.addEventListener('fullscreenchange', scheduleUpdate, { signal: controller.signal });
      window.addEventListener('scroll', scheduleUpdate, { passive: true, signal: controller.signal });
      window.addEventListener('resize', scheduleUpdate, { passive: true, signal: controller.signal });
      window.addEventListener('pageshow', scheduleUpdate, { signal: controller.signal });

      const intersectionObserver = new IntersectionObserver(scheduleUpdate, { threshold: [0, 1] });
      intersectionObserver.observe(mainButton);

      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        destroyed = true;
        controller.abort();
        buttonObserver.disconnect();
        overlayObserver.disconnect();
        intersectionObserver.disconnect();
        if (frame) window.cancelAnimationFrame(frame);
        delete root.dataset.nhProductInitialized;
      }, { signal: controller.signal });

      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

// Keep product reviews available from the rating badge without repeating a
// second review section in the page. The app's own widget and data are retained.
(() => {
  if (window.nhProductReviewDialog) return;
  window.nhProductReviewDialog = true;
  const lang = document.documentElement.lang.split('-')[0];
  const labels = ({
    it: { title: 'Recensioni', close: 'Chiudi le recensioni' },
    en: { title: 'Reviews', close: 'Close reviews' },
    es: { title: 'Reseñas', close: 'Cerrar reseñas' }
  })[lang] || { title: 'Reviews', close: 'Close reviews' };
  let dialog = null;
  let source = null;
  let placeholder = null;
  let trigger = null;
  let discovery = null;
  let badgeObserver = null;
  let overlayObserver = null;
  let suspended = false;

  const connectBadges = () => {
    document.querySelectorAll('[data-nh-product] .jdgm-prev-badge__stars, [data-nh-product] .jdgm-prev-badge__text').forEach((badge) => {
      if (badge.getAttribute('aria-controls') !== 'nh-product-review-dialog') {
        badge.setAttribute('aria-controls', 'nh-product-review-dialog');
        badge.setAttribute('aria-haspopup', 'dialog');
        if (badge.classList.contains('jdgm-prev-badge__text')) {
          badge.setAttribute('role', 'button');
          badge.tabIndex = 0;
        }
      }
    });
  };

  const initialize = () => {
    if (dialog) return;
    const product = document.querySelector('[data-nh-product]');
    const widget = document.querySelector('#judgeme_product_reviews');
    if (!product || !widget || typeof HTMLDialogElement === 'undefined') return;
    source = widget.closest('.shopify-section');
    placeholder = document.createComment('NH product reviews');
    widget.before(placeholder);
    dialog = document.createElement('dialog');
    dialog.id = 'nh-product-review-dialog';
    dialog.className = 'nh-reviews-dialog';
    dialog.setAttribute('aria-labelledby', 'nh-reviews-dialog-title');
    const bar = document.createElement('div');
    bar.className = 'nh-reviews-dialog__bar';
    const titleGroup = document.createElement('div');
    const title = document.createElement('h2');
    title.id = 'nh-reviews-dialog-title';
    title.textContent = labels.title;
    const productName = document.createElement('p');
    productName.className = 'nh-reviews-dialog__product';
    productName.textContent = product.querySelector('h1')?.textContent.trim() || '';
    titleGroup.append(title, productName);
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'nh-reviews-dialog__close';
    close.setAttribute('aria-label', labels.close);
    close.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m4 4 12 12M16 4 4 16" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
    const content = document.createElement('div');
    content.className = 'nh-reviews-dialog__content';
    bar.append(titleGroup, close);
    dialog.append(bar, content);
    document.body.append(dialog);
    content.append(widget);
    source?.classList.add('nh-reviews-source');
    close.addEventListener('click', () => dialog?.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (suspended) return;
      document.body.classList.remove('nh-reviews-open');
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    });
    // Judge.me renders its photo viewer and review form at document level.
    // Temporarily release the native top layer so those app dialogs remain
    // usable, then return to the review list when the app closes them.
    overlayObserver = new MutationObserver(() => {
      if (!dialog || (!dialog.open && !suspended)) return;
      const appOverlay = [...document.querySelectorAll('.jdgm-modal__content, .jdgm-write-review-modal')]
        .some((overlay) => {
          if (dialog.contains(overlay) || !overlay.getClientRects().length) return false;
          const style = getComputedStyle(overlay);
          return style.display !== 'none' && style.visibility !== 'hidden'
            && overlay.getAttribute('aria-hidden') !== 'true';
        });
      if (appOverlay && dialog.open) {
        suspended = true;
        dialog.close();
      } else if (!appOverlay && suspended) {
        suspended = false;
        dialog.showModal();
        dialog.querySelector('.nh-reviews-dialog__close').focus({ preventScroll: true });
      }
    });
    overlayObserver.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'hidden']
    });
    connectBadges();
    badgeObserver = new MutationObserver(connectBadges);
    badgeObserver.observe(product, { childList: true, subtree: true });
    discovery?.disconnect();
  };

  const openReviews = (event) => {
    const badge = event.target instanceof Element
      ? event.target.closest('[data-nh-product] .jdgm-preview-badge') : null;
    if (!badge || !dialog) return;
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger = event.target.closest('.jdgm-prev-badge__text, .jdgm-prev-badge__stars')
      || badge.querySelector('.jdgm-prev-badge__stars') || badge;
    if (!dialog.open) {
      dialog.showModal();
      document.body.classList.add('nh-reviews-open');
      dialog.querySelector('.nh-reviews-dialog__close').focus({ preventScroll: true });
      // The app can lay out its responsive contents after the hidden dialog opens.
      window.dispatchEvent(new Event('resize'));
    }
  };
  document.addEventListener('click', openReviews, true);
  document.addEventListener('keydown', openReviews, true);

  const start = () => {
    if (!document.querySelector('[data-nh-product]')) return;
    initialize();
    if (!dialog) {
      discovery?.disconnect();
      discovery = new MutationObserver(initialize);
      discovery.observe(document.body, { childList: true, subtree: true });
    }
  };
  document.addEventListener('shopify:section:unload', (event) => {
    if (source !== event.target && !event.target.querySelector('[data-nh-product]')) return;
    dialog?.close();
    const widget = dialog?.querySelector('#judgeme_product_reviews');
    if (source !== event.target && placeholder?.isConnected && widget) placeholder.replaceWith(widget);
    else placeholder?.remove();
    dialog?.remove();
    dialog = null;
    source?.classList.remove('nh-reviews-source');
    source = null;
    placeholder = null;
    badgeObserver?.disconnect();
    overlayObserver?.disconnect();
    suspended = false;
    discovery?.disconnect();
  });
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
